import React, { useEffect, useRef, useState } from "react";
import "./AnimatedSean.css";

import animationData from "../assets/images/SeanAnimated/exported_animation_info.json";

import SeanPants from "../assets/images/SeanAnimated/Sean_pants@.png";
import SeanTorso from "../assets/images/SeanAnimated/Sean_torso@.png";
import SeanRightArm from "../assets/images/SeanAnimated/Sean_rightArm@.png";
import SeanRightHand from "../assets/images/SeanAnimated/Sean_rightHand@.png";
import SeanLeftArm from "../assets/images/SeanAnimated/Sean_leftArm@.png";
import SeanLeftHand from "../assets/images/SeanAnimated/Sean_leftHand@.png";
import SeanHead from "../assets/images/SeanAnimated/Sean_head@.png";
import SeanHat from "../assets/images/SeanAnimated/Sean_Hat@.png";

const layerImages = {
  Sean_pants: SeanPants,
  Sean_torso: SeanTorso,
  Sean_rightArm: SeanRightArm,
  Sean_rightHand: SeanRightHand,
  Sean_leftArm: SeanLeftArm,
  Sean_leftHand: SeanLeftHand,
  Sean_head: SeanHead,
  Sean_Hat: SeanHat,
};

const baseLayout = {
  Sean_pants: {
    left: 147,
    top: 418,
    width: 157,
    height: 105,
    zIndex: 1,
  },
  Sean_torso: {
    left: 136,
    top: 193,
    width: 171,
    height: 239,
    zIndex: 2,
  },
  Sean_rightArm: {
    left: 60,
    top: 242,
    width: 115,
    height: 218,
    zIndex: 3,
  },
  Sean_rightHand: {
    left: 152,
    top: 422,
    width: 59,
    height: 57,
    zIndex: 4,
  },
  Sean_leftArm: {
    left: 264,
    top: 134,
    width: 137,
    height: 129,
    zIndex: 5,
  },
  Sean_leftHand: {
    left: 259,
    top: 81,
    width: 71,
    height: 68,
    zIndex: 6,
  },
  Sean_head: {
    left: 152,
    top: 117,
    width: 112,
    height: 100,
    zIndex: 7,
  },
  Sean_Hat: {
    left: 96,
    top: 60,
    width: 197,
    height: 107,
    zIndex: 8,
  },
};

const AnimatedSean = ({ className = "" }) => {
  const containerRef = useRef(null);
  const layerRefs = useRef({});
  const animationRef = useRef(null);
  const frameRef = useRef(animationData.startFrame || 0);
  const lastTimeRef = useRef(0);

  const [isPlaying, setIsPlaying] = useState(false);

  const applyFrame = (frameNumber) => {
    Object.keys(animationData.layers).forEach((layerName) => {
      const layer = animationData.layers[layerName];
      const element = layerRefs.current[layerName];

      if (!element || !layer || !layer.frames) return;

      const frame =
        layer.frames[frameNumber] ||
        layer.frames[animationData.startFrame || 0];

      if (!frame) return;

      const anchor = layer.anchor || {
        x: 0.5,
        y: 0.5,
      };

      const dx = frame.dx || 0;
      const dy = frame.dy || 0;
      const rotation = frame.rotation || 0;
      const scaleX = frame.scaleX || 1;
      const scaleY = frame.scaleY || 1;

      element.style.transformOrigin = `${anchor.x * 100}% ${
        anchor.y * 100
      }%`;

      element.style.transform = `
        translate(${dx}px, ${dy}px)
        rotate(${rotation}deg)
        scale(${scaleX}, ${scaleY})
      `;
    });
  };

  useEffect(() => {
    const startFrame = animationData.startFrame || 0;
    applyFrame(startFrame);
  }, []);

  useEffect(() => {
    const fps = animationData.frameRate || 30;
    const frameDuration = 1000 / fps;
    const startFrame = animationData.startFrame || 0;
    const endFrame = animationData.endFrame || 45;

    if (!isPlaying) {
      cancelAnimationFrame(animationRef.current);
      frameRef.current = startFrame;
      applyFrame(startFrame);
      return undefined;
    }

    const animate = (time) => {
      if (time - lastTimeRef.current >= frameDuration) {
        applyFrame(frameRef.current);
        frameRef.current += 1;

        if (frameRef.current > endFrame) {
          frameRef.current = startFrame;
        }

        lastTimeRef.current = time;
      }

      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [isPlaying]);

  useEffect(() => {
    const container = containerRef.current;

    if (!container) return undefined;

    const card =
      container.closest(".text-wrapper") || container.parentElement;

    if (!card) return undefined;

    const updateScale = () => {
  const cardWidth = card.getBoundingClientRect().width;
  const viewportWidth = window.innerWidth;

  // let ratio;

  // if (viewportWidth > 1200) {
  //   ratio = 0.82;
  // } else if (viewportWidth > 992) {
  //   ratio = 0.82;
  // } else if (viewportWidth > 768) {
  //   ratio = 0.82;
  // } else {
  //   ratio = 0.43;
  // }
  const ratio = viewportWidth > 768 ? 0.82 : 0.43;
  const targetCharacterWidth = cardWidth * ratio;
  const calculatedScale = targetCharacterWidth / 461;

  const scale = Math.min(
    0.82,
    Math.max(0.32, calculatedScale)
  );

  container.style.setProperty(
    "--sean-scale",
    scale.toString()
  );
};
   updateScale();
   const resizeObserver = new ResizeObserver(updateScale);
   resizeObserver.observe(card);

   window.addEventListener("resize", updateScale);

   return () => {
   resizeObserver.disconnect();
   window.removeEventListener("resize", updateScale);
};
    }, []);

  return (
    <div
      ref={containerRef}
      className={`animated-sean ${className}`}
      onMouseEnter={() => setIsPlaying(true)}
      onMouseLeave={() => setIsPlaying(false)}
    >
      <div className="animated-sean-stage">
        {Object.keys(baseLayout).map((layerName) => {
          const layout = baseLayout[layerName];

          return (
            <img
              key={layerName}
              ref={(element) => {
                layerRefs.current[layerName] = element;
              }}
              src={layerImages[layerName]}
              alt=""
              className="animated-sean-layer"
              style={{
                left: `${layout.left}px`,
                top: `${layout.top}px`,
                width: `${layout.width}px`,
                height: `${layout.height}px`,
                zIndex: layout.zIndex,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AnimatedSean;